/* ============================================================
   TDHQ QUICK VIEW - choosing a size without leaving the list.

   "Choose options" on a product card was a full page load, a decision, then
   Back and a re-scroll. It now opens the buy box over the grid: the product's
   pictures, its price, THE SAME option picker and size guide the product page
   renders (snippets/tdhq-option-picker), driven by the same engine
   (assets/tdhq-variants.js), and Add to basket hands over to the same basket
   drawer as everywhere else.

   PROGRESSIVE ENHANCEMENT: the control is a real link to the product page.
   Without this file - or if the fetch fails, or the browser has no <dialog> -
   the link does what it always did. Ctrl/cmd/middle click still opens the
   product page in a new tab.

   The markup is fetched on demand from the Section Rendering API:
     /products/<handle>?section_id=tdhq-quick-view
   so a listing page carries nothing for it until a shopper asks.
   ============================================================ */
(function () {
  'use strict';

  if (!('fetch' in window) || typeof DOMParser === 'undefined') { return; }
  var dlgProto = window.HTMLDialogElement && window.HTMLDialogElement.prototype;
  if (!dlgProto || typeof dlgProto.showModal !== 'function') { return; }

  /* "Choose options" and the Quick view eye on every card open the popup, and
     so do the "In Stock Now" suggestions on a sold-out product page (U.59): a
     shopper looks through them without losing the page they came from. */
  var CTA = 'a.tdhq-pcard__cta[href*="/products/"], a.tdhq-pcard__qv[href*="/products/"], a.dtc-pdp__instock-link[href*="/products/"]';
  var cache = {};
  var dialog = null;
  var content = null;
  var lastFocus = null;
  var currentToken = 0;

  function handleOf(href) {
    try {
      var u = new URL(href, window.location.origin);
      var m = u.pathname.split('/products/')[1];
      return m ? m.split('/')[0].split('?')[0] : '';
    } catch (e) { return ''; }
  }

  function fetchView(handle) {
    if (cache[handle]) { return cache[handle]; }
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=tdhq-quick-view';
    cache[handle] = fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.text();
      });
    cache[handle].catch(function () { delete cache[handle]; });
    return cache[handle];
  }

  function build() {
    if (dialog) { return; }
    dialog = document.createElement('dialog');
    dialog.className = 'tdhq-qv__dialog';
    dialog.setAttribute('aria-label', 'Quick view');
    dialog.innerHTML =
      '<button type="button" class="tdhq-qv__close" data-qv-close aria-label="Close quick view">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button><div class="tdhq-qv__content" data-qv-content></div>';
    /* the site's own close icon (layout template), like every other close
       button; the hand-drawn cross stays only as the fallback (REQ-VIS-10) */
    var closeTpl = document.getElementById('tdhq-close-icon');
    if (closeTpl && closeTpl.content && closeTpl.content.firstElementChild) {
      var cb = dialog.querySelector('[data-qv-close]');
      cb.textContent = '';
      cb.appendChild(closeTpl.content.firstElementChild.cloneNode(true));
    }
    document.body.appendChild(dialog);
    content = dialog.querySelector('[data-qv-content]');
    content.setAttribute('tabindex', '-1');

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-qv-close]'))) { close(); }
    });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { if (Date.now() - openedAt < 900) { centre(); } else { keepOnScreen(); } }).observe(dialog);
    }
    window.addEventListener('resize', centre);
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('tdhq-qv-open');
      if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); }
      lastFocus = null;
    });
  }

  function close() {
    if (dialog && dialog.open) { dialog.close(); }
  }

  /* LANDS IN THE MIDDLE, THEN HOLDS STILL (desktop). The panel opens centred
     on the screen (client, 2026-10-10); its top then stays where it landed, so
     an option that changes the panel's height grows it downwards instead of
     moving the whole popup (client, 2026-09-23). It moves up only when it
     would run off the bottom of the screen. The phone sheet keeps its bottom
     edge (no inline margin below 900px). */
  var wide = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
  var openedAt = 0;
  function centre() {
    if (!dialog) { return; }
    if (!dialog.open || !wide || !wide.matches) { dialog.style.marginTop = ''; return; }
    dialog.style.marginTop = Math.max(24, Math.round((window.innerHeight - dialog.offsetHeight) / 2)) + 'px';
  }
  function keepOnScreen() {
    if (!dialog || !dialog.open || !wide || !wide.matches || !dialog.style.marginTop) { return; }
    var room = window.innerHeight - 24 - dialog.offsetHeight;
    if (parseFloat(dialog.style.marginTop) > room) { dialog.style.marginTop = Math.max(24, Math.round(room)) + 'px'; }
  }

  /* The picture in the frame is swapped only once the new one has decoded, so
     the frame never goes blank - the same rule the product page follows. */
  function wireThumbs(root) {
    var stage = root.querySelector('.tdhq-qv__img');
    if (!stage) { return; }
    var thumbs = [].slice.call(root.querySelectorAll('[data-tdhq-qv-thumb]'));
    var token = 0;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-tdhq-qv-thumb');
        if (!src) { return; }
        thumbs.forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
        var mine = ++token;
        /* warmed and shown at the size the stage uses, not the full 900px file (TdhqImg) */
        var next = window.TdhqImg.warm(stage, src);
        var show = function () {
          if (mine !== token) { return; }
          fade(stage, function () {
            window.TdhqImg.swap(stage, src);
            /* this picture's own framing, not the last one's */
            if (window.tdhqFit && window.tdhqFit.reset) { window.tdhqFit.reset(stage); }
          });
        };
        (window.tdhqImgReady || function (i, ok) { if (i.complete) { ok(); } else { i.onload = ok; i.onerror = ok; } })(next, show);
      });
    });
  }

  /* A LOGO DRAWN WHITE for dark packaging vanishes on the white tile. The
     product page's sampler (snippets/tdhq-logo-well) is an inline script,
     which never runs in markup inserted here, so the same test runs here: a
     logo whose see-through edges surround light artwork gets the dark plate. */
  function lightLogo(root) {
    var well = root.querySelector('[data-brand-logo-well]');
    var img = well && well.querySelector('img');
    if (!img) { return; }
    function sample() {
      try {
        var c = document.createElement('canvas'); c.width = 40; c.height = 20;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, 40, 20);
        var d = x.getImageData(0, 0, 40, 20).data, sum = 0, n = 0, edge = 0, edgeN = 0;
        for (var py = 0; py < 20; py++) {
          for (var px = 0; px < 40; px++) {
            if (py > 0 && py < 19 && px > 0 && px < 39) { continue; }
            edgeN++; if (d[(py * 40 + px) * 4 + 3] > 128) { edge++; }
          }
        }
        if (edge / edgeN > 0.9) { return; }
        for (var i = 0; i < d.length; i += 4) { if (d[i + 3] > 40) { sum += (d[i] + d[i + 1] + d[i + 2]) / 3; n++; } }
        if (n && sum / n > 200) { well.classList.add('is-light-logo'); }
      } catch (e) { /* unreadable: keep the white tile */ }
    }
    if (img.complete && img.naturalWidth) { sample(); } else { img.addEventListener('load', sample, { once: true }); }
  }

  /* The same fade the product page's gallery uses (assets/tdhq-variants.js). */
  function fade(img, swap) {
    if (window.TdhqVariants && window.TdhqVariants.fadeSwap) { window.TdhqVariants.fadeSwap(img, swap); }
    else { swap(); }
  }

  /* The ring marks the picture the stage is SHOWING. It was left on the
     first thumb while the stage showed the chosen colour (audit pdp-12:
     sand hoodie ringed, blue hoodie shown), and never moved on a colour
     change. Matched by pathname: the JSON and the markup spell the same CDN
     file two ways. */
  function pathOf(u) {
    try { return new URL(u, window.location.origin).pathname; } catch (e) { return String(u || ''); }
  }
  function ringFor(root, src) {
    var want = pathOf(src);
    [].slice.call(root.querySelectorAll('[data-tdhq-qv-thumb]')).forEach(function (b) {
      if (pathOf(b.getAttribute('data-tdhq-qv-thumb')) === want) { b.setAttribute('aria-current', 'true'); }
      else { b.removeAttribute('aria-current'); }
    });
  }

  /* The dialog's ceiling follows its variant, exactly as the product page's
     does. Called on open and after every option change. */
  function syncQtyCeiling(root) {
    if (!window.TdhqQty) { return; }
    var input = root.querySelector('#QvQty');
    if (!input) { return; }
    /* The card pickers post the variant id from radios that live outside the
       form, so the id is resolved by the module rather than looked up here. */
    var vid = window.TdhqQty.variantOf(input);
    if (!vid) { return; }
    var known = window.TdhqQty.stock(vid);
    if (known !== null) { input.setAttribute('max', known); }
    else { input.removeAttribute('max'); }
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    input.value = window.TdhqQty.allowed(vid, input.value, 'add', min).value;
    window.TdhqQty.paint(input);
  }

  function wireQuantity(root) {
    [].slice.call(root.querySelectorAll('[data-pdp-step]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('#QvQty');
        if (!input) { return; }
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-pdp-step'), 10);
        /* Same clamp as the product page: the stock, less what the basket
           already holds. Quick view is a buy box and must not be the one
           place a shopper can ask for ten of three. */
        if (window.TdhqQty) {
          input.value = window.TdhqQty.allowed(
            window.TdhqQty.variantOf(input), next, 'add', min).value;
          window.TdhqQty.paint(input);
        } else {
          input.value = Math.max(min, next);
        }
      });
    });
  }

  /* Adding hands over to the basket drawer, exactly as a product card's quick
     add and the product page do: post, announce, let the drawer show it. */
  /* One request at a time (20 Oct, DA02): a second Enter or click while an add
     is running does nothing, and the button is disabled until it settles. A
     failure is said inside the dialog. The form is never re-submitted by the
     script: a lost reply does not mean the first add failed, so a retry could
     put the item in the basket twice. Without JavaScript the form still posts
     normally. */
  function wireAdd(root) {
    var form = root.querySelector('#QvForm');
    var btn = root.querySelector('[data-pdp-add]');
    if (!form || !btn) { return; }
    var pending = false;
    function say(msg) {
      /* over the bottom of the main picture, in the site's notification style (window.TdhqNote, 23 Oct 2026) */
      var stage = root.querySelector('.tdhq-qv__stage');
      if (window.TdhqNote && stage) {
        if (msg) { window.TdhqNote.show(stage, msg); } else { window.TdhqNote.clear(stage); }
        return;
      }
      var box = form.querySelector('.tdhq-qv__err');
      if (!msg) {
        if (box) { box.textContent = ''; box.hidden = true; }
        return;
      }
      if (!box) {
        box = document.createElement('p');
        box.className = 'tdhq-qv__err';
        box.setAttribute('role', 'alert');
        form.appendChild(box);
      }
      box.hidden = false;
      box.textContent = msg;
      if (window.TdhqMotion) { window.TdhqMotion.show(box); }
    }
    var pendingLabel = null;
    var addLabel = btn.querySelector('[data-pdp-add-text]');
    function settle() {
      pending = false;
      if (addLabel && pendingLabel !== null && addLabel.textContent === 'Adding…') { addLabel.textContent = pendingLabel; }
      pendingLabel = null;
      btn.classList.remove('is-adding');
      btn.removeAttribute('aria-busy');
      btn.disabled = btn.getAttribute('data-buyable') === 'false';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pending || btn.disabled) { return; }
      pending = true;
      if (addLabel) { pendingLabel = addLabel.textContent; addLabel.textContent = 'Adding…'; }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-adding');
      say('');
      /* A battery kit built from its parts (data-tdhq-kit-items, snippets/tdhq-kit-items.liquid) adds the parts as
         separate basket lines, each times the quantity, never the kit itself (owner + Simon, 20 Oct 2026). */
      var kitList = null;
      try { kitList = JSON.parse((form.getAttribute('data-tdhq-kit-items') || '').trim() || 'null'); } catch (err) { kitList = null; }
      if (!Array.isArray(kitList) || !kitList.length) { kitList = null; }
      var kitQty = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
      var data = new FormData(form);
      data.set('sections', 'tdhq-cart-state');
      data.set('sections_url', window.location.pathname);
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', kitList ? {
        method: 'POST',
        body: JSON.stringify({ items: kitList.map(function (p) { return { id: p[0], quantity: p[1] * kitQty }; }), sections: 'tdhq-cart-state', sections_url: window.location.pathname }),
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      } : {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (err) {
            var fail = new Error(err.description || err.message || '');
            fail.fromShop = true;
            throw fail;
          });
        }
        return r.json();
      }).then(function (item) {
        settle();
        close();
        document.dispatchEvent(new CustomEvent('tdhq:cart:added', {
          detail: { productId: item && (item.product_id || (item.items && item.items[0] && item.items[0].product_id)), item: item }
        }));
      }).catch(function (err) {
        settle();
        say(err && err.fromShop && err.message
          ? err.message
          : 'We could not confirm the add. Please check your basket before trying again.');
        /* a refused kit add may still have put some of its parts in the basket */
        if (kitList && window.TdhqQty && window.TdhqQty.reconcile) { window.TdhqQty.reconcile(); }
      });
    });
  }

  function paintFromVariant(root, v) {
    if (!v) { return; }
    var addText = root.querySelector('[data-pdp-add-text]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var stockEl = root.querySelector('[data-pdp-stock]');
    var stockText = root.querySelector('[data-pdp-stock-text]');
    var unitEl = root.querySelector('[data-pdp-unit]');
    if (priceEl) {
      var html = '<span class="dtc-pdp__now' + (v.compare_at ? ' dtc-pdp__now--sale' : '') + '">' + v.price + '</span>';
      if (v.compare_at) { html += ' <s class="dtc-pdp__was" aria-hidden="true">' + v.compare_at + '</s>'; }
      if (v.saving) { html += ' <span class="dtc-pdp__saving">Save ' + v.saving + '</span>'; }
      var priceWas = priceEl.textContent;
      priceEl.innerHTML = html;
      if (priceWas !== priceEl.textContent && window.TdhqMotion) { window.TdhqMotion.figure(priceEl); }
    }
    if (unitEl) {
      var unitVal = unitEl.querySelector('[data-pdp-unit-value]');
      if (unitVal) { unitVal.textContent = v.unit_price || ''; }
      unitEl.hidden = !v.unit_price;
    }
    if (stockEl) {
      stockEl.className = 'dtc-pdp__stockline dtc-pdp__stockline--' + (v.stock_state || (v.available ? 'in' : 'out'));
      if (stockText) { stockText.textContent = v.stock_label || (v.available ? 'In stock' : 'Out of stock'); }
      stockEl.hidden = !(v.stock_label || !v.available);
    }
    /* THE PRODUCT PAGE'S SOLD-OUT STATE: no quantity box beside "Out of
       stock", the two ways on instead, and no Click & Collect line for what
       cannot be bought. The SKU and the offer flag follow the choice too. */
    var buyrow = root.querySelector('[data-pdp-buyrow]');
    if (buyrow) { buyrow.classList.toggle('is-soldout', !v.available); }
    var soldhelp = root.querySelector('[data-pdp-soldhelp]');
    if (soldhelp) { soldhelp.hidden = !!v.available; }
    var backask = root.querySelector('[data-qv-backask]');
    if (backask && v.id) { backask.setAttribute('href', backask.getAttribute('href').replace(/variant=\d+/, 'variant=' + v.id)); }
    /* Click & Collect keeps its place: an option that cannot be collected
       shows the panel's quiet state (snippets/tdhq-pickup.liquid) */
    var pickup = root.querySelector('[data-pdp-pickup]');
    if (pickup) {
      pickup.classList.toggle('is-off', !v.pickup);
      /* U.61: the JSON's "no" is only certain for the option the box was rendered with; ask Shopify for the rest. */
      pickup.setAttribute('data-pickup-for', v.id);
      if (!v.pickup && v.available && window.tdhqPickupFor) {
        window.tdhqPickupFor(v.id).then(function (on) {
          if (on && pickup.getAttribute('data-pickup-for') === String(v.id)) { pickup.classList.remove('is-off'); }
        });
      }
    }
    /* the rewards line gives way to the sold-out links, as on the product page */
    var qvPoints = root.querySelector('[data-qv-points]');
    if (qvPoints && typeof v.points === 'number') {
      qvPoints.hidden = v.points <= 0;
      var qvN = qvPoints.querySelector('[data-qv-points-n]');
      var qvW = qvPoints.querySelector('[data-qv-points-word]');
      if (qvN) { qvN.textContent = v.points; }
      if (qvW) { qvW.textContent = v.points === 1 ? 'point' : 'points'; }
    }
    var sku = root.querySelector('[data-pdp-sku]');
    if (sku) {
      var skuVal = sku.querySelector('[data-pdp-sku-value]');
      if (skuVal) { skuVal.textContent = v.sku || ''; }
      sku.hidden = !v.sku;
    }
    var flag = root.querySelector('[data-qv-flag]');
    if (flag) {
      flag.hidden = !v.save_pct;
      if (v.save_pct) { flag.textContent = 'Save ' + v.save_pct + '%'; }
    }
    if (addBtn) {
      addBtn.setAttribute('data-buyable', v.buyable ? 'true' : 'false');
      addBtn.disabled = !v.buyable || addBtn.getAttribute('aria-busy') === 'true';
      if (addText) {
        addText.textContent = v.buyable
          ? (addBtn.getAttribute('data-in-label') || 'Add to basket')
          : (v.available ? (addBtn.getAttribute('data-poa-label') || 'Price on request')
                         : (addBtn.getAttribute('data-sold-label') || 'Out of stock'));
      }
    }
    /* A picture for the chosen variant, when it has one of its own. */
    var stage = root.querySelector('.tdhq-qv__img');
    if (stage && v.image) {
      ringFor(root, v.image);
      if (pathOf(stage.currentSrc || stage.src) === pathOf(v.image)) { return; }
      var mine = root.__qvPic = (root.__qvPic || 0) + 1;
      var next = window.TdhqImg.warm(stage, v.image);
      var show = function () {
        if (mine !== root.__qvPic) { return; }
        fade(stage, function () {
          window.TdhqImg.swap(stage, v.image);
          if (window.tdhqFit && window.tdhqFit.reset) { window.tdhqFit.reset(stage); }
        });
      };
      (window.tdhqImgReady || function (i, ok) { if (i.complete) { ok(); } else { i.onload = ok; i.onerror = ok; } })(next, show);
    }
  }

  /* A GIFT CARD OPENS THE GIFT CARD POPUP (22 Oct 2026, owner: its quick view showed the card's own amounts, not the
     Digital / Physical choice). Both cards are bought through the one gift card box, in its popup, which the product
     page's gift line fetches on demand (snippets/tdhq-pdp-aside.liquid): same request, same script, opened on the
     card's own format. The popup's script wires a popup that arrives after it loaded. */
  var giftBusy = false;
  function openGift(fmt, js, link) {
    var go = function () { window.tdhqGiftCard.open(fmt, null, null); };
    if (document.querySelector('[data-gcx-popup]') && window.tdhqGiftCard && window.tdhqGiftCard.open) { go(); return; }
    if (giftBusy || !js) { if (!js) { window.location.href = link.href; } return; }
    giftBusy = true;
    link.classList.add('is-loading');
    fetch('/?section_id=tdhq-gift-popup', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        if (!holder.querySelector('[data-gcx-popup]')) { throw new Error('no popup'); }
        holder.querySelectorAll('script').forEach(function (s) { s.parentNode.removeChild(s); });
        document.body.appendChild(holder);
        var css = holder.querySelector('link[rel="stylesheet"]');
        var cssReady = new Promise(function (res) {
          if (!css || css.sheet) { res(); return; }
          css.addEventListener('load', res); css.addEventListener('error', res); setTimeout(res, 3000);
        });
        var jsReady = new Promise(function (res, rej) {
          if (window.tdhqGiftCard && window.tdhqGiftCard.open) { res(); return; }
          var s = document.createElement('script'); s.src = js; s.onload = res; s.onerror = rej; document.head.appendChild(s);
        });
        return Promise.all([cssReady, jsReady]);
      })
      .then(go)
      .catch(function () { window.location.href = link.href; })
      .then(function () { giftBusy = false; link.classList.remove('is-loading'); });
  }

  function open(link, byKey) {
    var handle = handleOf(link.getAttribute('href'));
    if (!handle) { window.location.href = link.href; return; }
    build();
    lastFocus = link;
    var mine = ++currentToken;
    link.classList.add('is-loading');
    fetchView(handle).then(function (html) {
      link.classList.remove('is-loading');
      if (mine !== currentToken) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var view = doc.querySelector('[data-tdhq-qv]');
      if (!view) { window.location.href = link.href; return; }
      var giftFmt = view.getAttribute('data-qv-giftcard');
      if (giftFmt) { openGift(giftFmt, view.getAttribute('data-qv-gcjs'), link); return; }
      content.innerHTML = '';
      content.appendChild(document.importNode(view, true));
      var root = content.firstElementChild;
      if (window.TdhqVariants) {
        window.TdhqVariants.init(root, { onChange: function (v) {
          paintFromVariant(root, v);
          /* The chosen variant's stock, before the shopper can ask for more
             of it than exists. */
          if (window.TdhqQty && v && v.id) { window.TdhqQty.remember(v.id, v.qty_max || 0); }
          syncQtyCeiling(root);
        } });
      }
      wireThumbs(root);
      wireQuantity(root);
      lightLogo(root);
      /* THE CEILING HOLDS FROM THE FIRST PRESS. The stock module learns a
         ceiling only from a box Liquid rendered at page load, or from a
         variant CHANGE - and opening quick view is neither, so the box lost
         the max its own markup carried and "+" went to 9 of 4 (audit pdp-02,
         measured on a fresh listing). Every variant's ceiling is handed over
         from the picker's data before the box is judged. A listing also never
         reads the basket, so 4 already in it still allowed 4 more: the basket
         is read now and the box judged again when it answers. */
      var vdata = root.querySelector('[data-pdp-variants]');
      if (window.TdhqQty && vdata) {
        try {
          JSON.parse(vdata.textContent).forEach(function (vv) { window.TdhqQty.remember(vv.id, vv.qty_max || 0); });
        } catch (err) {}
      }
      syncQtyCeiling(root);
      if (window.TdhqQty && window.TdhqQty.readBasket) {
        window.TdhqQty.readBasket().then(function () {
          if (mine === currentToken && content.contains(root)) { syncQtyCeiling(root); }
        });
      }
      wireAdd(root);
      /* saved state on the Save for later button, which arrived after load */
      if (window.tdhqWishPaint) { window.tdhqWishPaint(root); }
      if (window.tdhqFit) { window.tdhqFit.scan(); }
      document.documentElement.classList.add('tdhq-qv-open');
      dialog.showModal();
      content.scrollTop = 0;
      openedAt = Date.now();
      centre();
      /* LONG OPTION LISTS STAY ONE ROW: the tiles become the site's own rail
         (drag, snap, and the bar and arrows, which appear only when the row
         overflows). Wired once the popup is open, so the rail measures its
         real width. */
      root.querySelectorAll('.tdhq-opt__vals--tiles, .tdhq-opt__vals--priced').forEach(function (el) {
        el.setAttribute('data-dtc-drag', '');
      });
      if (window.dtcRevealRefresh) { window.dtcRevealRefresh(); }
      /* FOCUS WHERE IT HELPS. Opened from the keyboard, focus goes to the
         first choice (or Add to basket) and shows its ring. Opened with a
         pointer, the panel itself takes focus and no control is ringed: the
         yellow ring sat on Add to basket after every click (client
         screenshot). Tab still starts inside the popup. */
      var first = byKey ? root.querySelector('.tdhq-opt__v input, [data-pdp-add]') : null;
      if (first && first.focus) { first.focus({ preventScroll: true }); }
      else { content.focus({ preventScroll: true }); }
    }).catch(function () {
      link.classList.remove('is-loading');
      window.location.href = link.href;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) { return; }
    var link = e.target && e.target.closest ? e.target.closest(CTA) : null;
    if (!link || link.target === '_blank') { return; }
    e.preventDefault();
    /* a click with no pointer (detail 0) came from Enter on the link */
    open(link, e.detail === 0);
  });

  /* Warm the view on intent, so the popup opens on the click. */
  function prefetch(e) {
    var link = e.target && e.target.closest ? e.target.closest(CTA) : null;
    if (!link) { return; }
    var handle = handleOf(link.getAttribute('href'));
    if (handle && !cache[handle]) { fetchView(handle).catch(function () {}); }
  }
  document.addEventListener('pointerenter', prefetch, true);
  document.addEventListener('focusin', prefetch);
})();
